import { get } from "_src/utils/http";

export function getHomeBannerList(data) {
  return get("/api/inftspace/navigations/v1/get_home_banner_list", data).then(
    (res) => {
      return res;
    }
  );
}

export function getNavigationsList(data) {
  return get("/api/inftspace/navigations/v1/get_navigations_list", data).then(
    (res) => {
      return res;
    }
  );
}

export function getWeMediaList(data) {
  return get("/api/inftspace/navigations/v1/get_we_media_list", data).then(
    (res) => {
      return res;
    }
  );
}
